import { FunctionalComponent } from 'preact';
import { useEffect } from 'preact/hooks';
import { Icon, IconProps } from '@accedo/ctv-ui-icons';
import HomeIcon from '@accedo/ctv-ui-icons/assets/app-navigation/home.svg';
import TVGuideIcon from '@accedo/ctv-ui-icons/assets/app-navigation/tv-guide.svg';
import MovieIcon from '@accedo/ctv-ui-icons/assets/app-navigation/movies.svg';
import { Nav } from '@accedo/spatial-nav';
import { logger } from '@accedo/logger';
import { setLoadingIndicatorVisibility } from '##/components/LoadingIndicator';
import { nav } from '##/services/navigation';
import { useMenu } from '##/context/MenuContext';
import styles from './IconTestPage.module.scss';

const pageId = 'IconTestPage';
const LP = '[IconTestPage]';

// Match the viewBox to that of the SVG source file, and then it will scale as needed
const IconWrapper: FunctionalComponent<IconProps & { id: string }> = ({ id, source }) => (
  <Nav.Focusable id={id}>
    <div id={id} className={styles.iconContainer}>
      <Icon source={source} expandDataImage attributes={{ viewBox: '0 0 24 24' }} />
      {/* {toIconElement(source, { expandDataImage: true, attributes: { viewBox: '0 0 24 24' } })} */}
    </div>
  </Nav.Focusable>
);

/*
Use this page for whatever you need to during dev
*/
export const IconTestPage: FunctionalComponent = () => {
  useMenu(true);

  useEffect(() => {
    logger.debug(`${LP} useEffect - no dependencies`);
    nav.assignFocus(pageId);
    setLoadingIndicatorVisibility(false);
  }, []);

  return (
    <Nav.Vertical id={pageId}>
      <div id={pageId} className={styles.iconTestPage}>
        <span>Icon Test Page</span>
        <div className={styles.row} id={pageId}>
          <Nav.Vertical id={`${pageId}-grid`} isIndexAlign>
            <Nav.Horizontal id={'app-navigation'}>
              <div className={styles.row}>
                <IconWrapper id={'home'} source={`${HomeIcon}#home`} />
                <IconWrapper id={'tv-guide'} source={`${TVGuideIcon}#tv-guide`} />
                <IconWrapper id={'movies'} source={`${MovieIcon}#movies`} />
              </div>
            </Nav.Horizontal>
          </Nav.Vertical>
        </div>
      </div>
    </Nav.Vertical>
  );
};
